// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","label":"imageOption_label__TXeiA","image":"imageOption_image___J2zU","isRound":"imageOption_isRound__y3ARD","input":"imageOption_input__0ZeRl"};